<template>
  <div class="d-flex flex-column align-items-center h-100 justify-content-center">
      <h1 class="text-primary" style="font-size: 100px">404</h1>
      <p class="mt-4">Page non trouvée</p>
      <p>
        Oups ! La page que vous cherchez n’existe pas ou a été déplacée.
      </p>
      <button
          @click="$router.push('/')"
          class="btn bt-challenges btn-secondary"
      >
        Retour à l’accueil
      </button>
  </div>
</template>

<script>

export default {
  name:"404",
    components:{
    },   
  data () {
    return {
    }
  },
  methods : {
  }
};
</script>
